import JSZip from 'jszip';
import { buildSeatMapSnapshot, getSeatMapFileName, renderSeatMapPng } from './seatMapSnapshot';

// Render one session at a time; share only the venue drawing, never its inventory.
export const createSeatMapArchive = async ({
    sessions, loadSession, loadVenueSvg, onProgress = () => {}, isCanceled = () => false,
    renderPng = renderSeatMapPng,
}) => {
    const generatedSessions = sessions.filter(session => session.isGenerated);
    if (!generatedSessions.length) throw new Error('There are no generated session layouts to download.');
    const archive = new JSZip();
    const svgByVenue = new Map();
    onProgress(0, generatedSessions.length);
    for (const [index, session] of generatedSessions.entries()) {
        if (isCanceled()) return null;
        try {
            if (!svgByVenue.has(session.venueId)) {
                svgByVenue.set(session.venueId, await loadVenueSvg(session.venueId));
            }
            if (isCanceled()) return null;
            const { seats, capacityRows, generatedAt } = await loadSession(session);
            if (isCanceled()) return null;
            const snapshot = buildSeatMapSnapshot({
                svgText: svgByVenue.get(session.venueId), seats, capacityRows, session, generatedAt,
            });
            const png = await renderPng(snapshot);
            if (isCanceled()) return null;
            // A prefix prevents identical/sanitized venue names from overwriting a file.
            archive.file(`${String(index + 1).padStart(2, '0')}_${getSeatMapFileName(session)}`, png);
            onProgress(index + 1, generatedSessions.length);
        } catch (error) {
            if (isCanceled()) return null;
            throw new Error(`${session.venue} / ${session.date} / ${session.displayTime || session.time}: ${error.message || 'The session image could not be created.'}`);
        }
    }
    if (isCanceled()) return null;
    const content = await archive.generateAsync({ type: 'uint8array' });
    return isCanceled() ? null : content;
};
